module.exports = __webpack_public_path__ + "img/20200107160049060.caada1bd.jpg";